export default __webpack_public_path__ + "static/media/Major Rune Stone of the Proven Champion.a3fb6df2.jpg";